import * as React from 'react';
import { SiteRoute } from '@journeyapps/package-types';
import { faCode, faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CardGridWidget } from '../CardGridWidget';
import { CardWidget } from '../CardWidget';
import { HomeSectionHeader } from './HomeSectionHeader';

export const HomeDocsSection: React.FC = () => (
  <section aria-labelledby="home-docs">
    <HomeSectionHeader id="home-docs" title="Explore the docs." to={SiteRoute.DOCS} linkLabel="All docs" />
    <CardGridWidget columns={2}>
      <CardWidget
        href="/docs/get-started/tutorial-build-your-first-app/"
        icon={<FontAwesomeIcon icon={faGraduationCap} />}
        title="Build your first app."
        description="Build Site Inspector step by step, from your first project in OXIDE to a released app."
        action="Start the tutorial"
      />
      <CardWidget
        href="/docs/get-started/syntax/"
        icon={<FontAwesomeIcon icon={faCode} />}
        title="Learn Platform syntax."
        description="See how XML, JavaScript and TypeScript work together across views, bindings, and events."
        action="Explore the syntax"
      />
    </CardGridWidget>
  </section>
);
